const colors = {
  primary: "#367cbc",
  primaryDark: "#2a5e8c",
  backgroundDark: "#191919",
  backgroundDarker: "#121212",
  backgroundLight: "#f6f6f6",
  backgroundLighter: "#ffffff",
  textDark: "#131313",
  textDarkSecondary: "#4b4b4b",
  textLight: "#f6f6f6",
  textLightSecondary: "#cfcfcf",

  nePasOublier: "#bcbbd5",
  quotidien: "#bbd9ce",
  cours: "#f8785b",
  integration: "#ffdb9d",

  vivreAStrasbourg: "#CD4242",
  vivreATps: "#367CBC",

  black: "#000000",
  grey: "#424242",
  white: "#ffffff",
};

export default colors;
